import { TextError } from "../../errors/TextError/TextError";
import "./Select.css";

interface SelectItem {
  uuid: string;
  name: string;
}

interface SelectProps {
  name: string;
  items: SelectItem[] | undefined;
  label?: string;
  placeholder: string;
  width?: string;
  margin?: string;
  value: string;
  action: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  textError?: string;
}

export const Select = ({
  name,
  items,
  label,
  placeholder,
  width,
  margin,
  value,
  action,
  textError,
}: SelectProps) => {
  const styles = {
    width: width || "20rem",
    margin: margin || "0",
  };

  return (
    <div className="select" style={styles}>
      {label && <label htmlFor={name}>{label}</label>}
      <select id={name} value={value} onChange={action}>
        <option value="" disabled>
          {placeholder}
        </option>
        {items &&
          items.map((item) => (
            <option key={item.uuid} value={item.uuid}>
              {item.name}
            </option>
          ))}
      </select>
      <TextError text={textError} />
    </div>
  );
};
